import { Injectable, Output, EventEmitter } from '@angular/core';
import { Observable } from 'rxjs/Observable';

import { Document } from 'app/shared/models/document.model';

import { ConstantsService } from 'app/services/constants-service';
import { ObservableRequestService } from 'app/services/observable-request.service';
import { CookieService } from './../../services/cookie.service';

/**
 * Service for entity documents tab.
 */
@Injectable()
export class EntityDocumentsService {
  @Output()
  updatedDoucment: EventEmitter<Object> = new EventEmitter();

  constructor(private requestService: ObservableRequestService,
    private cookieService: CookieService) { }

  getDocumentLabels(): Observable<any> {
    return this.requestService.getRequest(ConstantsService.DOCUMENT_LABELS);
  }

  addDocumentLabel(body): Observable<any> {
    return this.requestService.postRequest(
      ConstantsService.DOCUMENT_LABELS,
      this.requestService.serialize(body),
      this.requestService.getFormEncodedContentType());
  }

  addDocument(document: Array<Document>): Observable<any> {
    return this.requestService.postRequest(
      ConstantsService.DOCUMENT,
      JSON.stringify(document),
      this.requestService.getJSONContentType());
  }

  deleteDocumentLabel(documentId, labelId): Observable<any> {
    const url = ConstantsService.DOCUMENT_LABELS + '/' + documentId + '/' + labelId;
    return this.requestService.deleteRequest(
      url,
      this.requestService.serialize(''),
      this.requestService.getJSONContentType());
  }

  deleteDocument(documentId): Observable<any> {
    const url = ConstantsService.DOCUMENT + '/' + documentId;
    return this.requestService.deleteRequest(
      url,
      this.requestService.serialize(''),
      this.requestService.getJSONContentType());
  }

  listDocuments(entityId, labelId): Observable<any> {
    const url = ConstantsService.DOCUMENT + '/' + entityId + '/' + labelId;
    return this.requestService.getRequest(url);
  }

  uploadNewDocument(files, entityId): XMLHttpRequest {
    const addEntityIdToForm = (formData: FormData) => formData.append('entityId', entityId);
    return this.uploadDocument(files, ConstantsService.DOCUMENT_UPLOAD, addEntityIdToForm);
  }

  updateExistingDocument(files, documentId): XMLHttpRequest {
    const addDocumentIdToForm = (formData: FormData) => formData.append('documentId', documentId);
    return this.uploadDocument(files, ConstantsService.DOCUMENT_REUPLOAD, addDocumentIdToForm);
  }

  private uploadDocument(files, url: string, addFormDataLambda: any): XMLHttpRequest {
    const formData: FormData = new FormData();

    for (let i = 0; i < files.length; i++) {
      formData.append('files', files.item(i), files.item(i).name);
    }
    addFormDataLambda(formData);

    const xhr: XMLHttpRequest = new XMLHttpRequest();
    xhr.open('PUT', ConstantsService.APP_BE_URL + "/rest" + url, true);
    xhr.setRequestHeader('Authorization',
      'Bearer ' + this.cookieService.get(ConstantsService.COOKIE_ACCESS_TOKEN));
    xhr.setRequestHeader('app-type', 'TRUST');
    xhr.send(formData);
    return xhr;
  }

  searchDocument(documentSearch): Observable<any> {
    return this.requestService.postRequest(
      ConstantsService.SEARCH_DOCUMENTS_BY_NAME_AND_CONTENT,
      JSON.stringify(documentSearch),
      this.requestService.getJSONContentType());
  }
}



// WEBPACK FOOTER //
// ./src/app/entities/documents/entity-documents.service.ts